import React from 'react';

const CustomerServiceDescription = ({ formData, setFormData, isDescriptionEmpty }) => {
    return (
        <div
            className={`p-4 border ${
                isDescriptionEmpty ? 'border-red-500' : 'border-gray-300'
            } rounded-lg`}
        >
            <label className='block text-sm font-medium text-gray-700'>
                Kundens ønsker til servicen: (Skriv utfyllende om hvilket arbeid som ønskes utføres)
            </label>
            <textarea
                name='beskrivelse'
                value={formData.beskrivelse}
                onChange={(e) => setFormData({ ...formData, beskrivelse: e.target.value })}
                required
                rows='3'
                className='mt-1 block w-full p-2 border border-gray-300 rounded-md resize-y'
            />
            {isDescriptionEmpty && (
                <p className='text-red-500 text-sm mt-2'>Beskrivelse må fylles ut.</p>
            )}
        </div>
    );
};

export default CustomerServiceDescription;
